<template>
  <div class="py-1">
    <eg-additional-collapse
      class="canvas_collapse"
      :label="$t('imports.canvas.step1Label')"
      accordion="accordion"
      :value="true"
    >
      <template v-if="isUrlValid" #status-icon>
        <eg-icon icon="check-circle" color="success" size="large" />
      </template>
      <ol class="mt-3 pl-4">
        <li>{{ $t("imports.canvas.step1Instruction1") }}</li>
        <li>{{ $t("imports.canvas.step1Instruction2") }}</li>
      </ol>

      <eg-form-group
        :label="$t('imports.canvas.urlLabel')"
        class="custom-from-group"
      >
        <eg-input
          v-model="localData.canvasUrl"
          :placeholder="$t('imports.canvas.urlPlaceholder')"
          :state="isUrlValid ? 'success' : 'default'"
          :show-validation="false"
        />
        <span class="hint">{{ $t("imports.canvas.urlHint") }}</span>
      </eg-form-group>
    </eg-additional-collapse>

    <eg-additional-collapse
      class="canvas_collapse mt-4"
      :label="$t('imports.canvas.step2Label')"
      accordion="accordion"
    >
      <template v-if="isTokenValid" #status-icon>
        <eg-icon icon="check-circle" color="success" size="large" />
      </template>
      <ol class="mt-3 pl-4">
        <li>{{ $t("imports.canvas.step2Instruction1") }}</li>
        <li>{{ $t("imports.canvas.purposeField") }}</li>
        <li>{{ $t("imports.canvas.leaveExpires") }}</li>
        <li>{{ $t("imports.canvas.generateToken") }}</li>
        <li>{{ $t("imports.canvas.pasteToken") }}</li>
      </ol>
      <eg-form-group
        :label="$t('imports.canvas.tokenLabel')"
        class="custom-from-group"
      >
        <eg-input
          v-model="localData.canvasToken"
          :placeholder="$t('imports.canvas.tokenPlaceholder')"
          :state="isTokenValid ? 'success' : 'default'"
          :show-validation="false"
        />
      </eg-form-group>
    </eg-additional-collapse>
  </div>
</template>
<script>
import isURL from "validator/es/lib/isURL";
import EgAdditionalCollapse from "@/components/global/eg_additional_collapse.vue";
import EgFormGroup from "@/components/global/eg_form_group.vue";

export default {
  components: {
    EgAdditionalCollapse,
    EgFormGroup,
  },

  props: {
    value: {
      type: Object,
      default: () => ({ canvasUrl: "", canvasToken: "" }),
    },
  },

  data() {
    return {
      localData: { ...this.value },
    };
  },

  computed: {
    isUrlValid() {
      return this?.localData?.canvasUrl
        ? isURL(this?.localData?.canvasUrl)
        : false;
    },
    isTokenValid() {
      return this.localData?.canvasToken?.trim().length > 0 ? true : null;
    },
  },

  watch: {
    localData: {
      deep: true,
      handler(newVal) {
        this.$emit("input", newVal);
      },
    },
  },
};
</script>

<style scoped lang="scss">
.custom-from-group {
  margin-bottom: 0;

  // TODO:Oleh: why it is not 16px as sidebar has?
  &::v-deep {
    .col-form-label {
      font-weight: var(--typography-font-weight-fw-600);
      font-size: var(--typography-font-size-fs-300);
      padding-bottom: 0.5rem;
    }
  }
}

.hint {
  font-size: var(--typography-font-size-fs-200);
  color: var(--color-text-neutral-fade);
}
</style>
